import dayjs from 'dayjs'

const getFullDate = date =>
  dayjs(date).isValid() ? dayjs(date).format('DD/MM/YYYY HH:mm') : null

export default getFullDate
